<template>
  <v-layout
    column
    id="outbox"
    class="overflow-y-hidden"
    style="position: relative;"
  >
    <v-flex>
      <v-toolbar
        dense
      >
        <v-toolbar-items>

        <v-btn
          flat
          @click="viewInbox"
        >Go To Inbox</v-btn>

        </v-toolbar-items>
          <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-text-field v-model="outboxSearch" append-icon="search" />
        </v-toolbar-items>
      </v-toolbar>
    </v-flex>

    <v-flex id="outbox-messages">
      <v-layout row justify-space-between align-center class="my-4">
        <v-flex>
          <h1 class="my-2">Sent</h1>
        </v-flex>

        <v-flex justify-self-end class="text-xs-right">
          <v-pagination
            v-model="outboxPage"
            :length="outboxPageLength"
          />
        </v-flex>
      </v-layout>

      <h3 v-if="outboxSearch" class="my-2 grey--text">Messages matching '{{ outboxSearch }}'...</h3>

      <v-progress-linear indeterminate v-if="searching" />
      <v-list v-else two-line style="height: 70vh; overflow-y: scroll;">
        <template v-for="(message, i) in messageList">

          <v-layout
            v-if="viewedMessage && message.id == viewedMessage.id"
            class="py-2 grey lighten-5"
            column
          >
            <v-flex>
              <v-toolbar dense class="white" :class="[`${ viewedMessage.systemMessage ? 'blue lighten-5' : '' }`]">
                <v-toolbar-side-icon
                  @click="collapseMessage"
                >
                  <v-icon>unfold_less</v-icon>
                </v-toolbar-side-icon>

                <v-toolbar-items>
                </v-toolbar-items>
                <v-spacer></v-spacer>
                  <v-tooltip top>
                    <v-btn
                      v-if="!viewedMessage.archived"
                      flat
                      slot="activator"
                      @click="archive(viewedMessage)"
                    >
                      <v-icon>archive</v-icon>
                    </v-btn>
                    Archive
                  </v-tooltip>
              </v-toolbar>
            </v-flex>

            <v-flex class="pa-4 white" :class="{ 'flagged-border': message.flagged }" >
              <h2>{{ viewedMessage.subject }}</h2>
              <h3 class="message-details font-weight-regular mb-2"><span class="subtle font-weight-regular">To</span> {{ viewedMessage.recipientName }} <span class="subtle font-weight-regular">at {{ viewedMessage.sentAt | moment('h:mma on dddd, MMMM Do') }}</span></h3>
              <div style="white-space: pre-wrap" v-html="viewedMessage.message"></div>
            </v-flex>

            <v-flex>
              <v-toolbar dense flat class="white" :class="{ 'flagged-border': message.flagged }">
                <v-toolbar-items>
                </v-toolbar-items>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-btn
                    v-if="replyingToMessage"
                    flat
                    color=secondary
                    @click="discardMessage()"
                  >Discard</v-btn>
                  <v-btn
                    v-if="replyingToMessage"
                    color=primary
                    :disabled="!composeFieldsPresent"
                    :loading="messageSending"
                    @click="sendMessage()"
                  >Send</v-btn>
                </v-toolbar-items>
              </v-toolbar>
            </v-flex>
          </v-layout>

          <v-list-tile
            v-else
            :class="messageClasses(message)"
            @click="viewMessage(message)"
            class="message-in-list px-1"
          >
            <v-icon class="hover-expand">
              unfold_more
            </v-icon>
            <v-list-tile-content>
            <div @click.stop class="inbox-tools white">
              <div>
                <v-btn
                  v-if="!message.archived"
                  small
                  icon
                  @click="archive(message)"
                >
                  <v-icon>archive</v-icon>
                </v-btn>
              </div>
            </div>
              <v-list-tile-title>
                <v-layout row justify-space-between>
                  <v-flex grow :class="">
                    {{ truncate(message.subject, 80) }}
                  </v-flex>
                  <v-flex shrink>
                    <div v-if="$moment(message.sentAt).isBefore($moment().startOf('day'))">
                      {{ message.sentAt | moment('dddd, MMMM Do') }}
                    </div>
                    <div v-else>
                      {{ message.sentAt | moment('h:mm a') }}
                    </div>
                  </v-flex>
                </v-layout>
              </v-list-tile-title>

              <v-list-tile-sub-title>
                <span class="black--text">To {{ message.recipientName }}</span> - {{ message.message }}
              </v-list-tile-sub-title>
            </v-list-tile-content>

            </div>
          </v-list-tile>
          <v-divider></v-divider>
        </template>
      </v-list>
    </v-flex>
  </v-layout>

</template>

<script>
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'

export default {
  created () {
    this.fetchData()
  },
  computed: {
    ...mapState('userAuth', [
      'user'
    ]),
    ...mapState('messages', [
      'outboxMessages',
    ]),
    ...mapGetters('messages', [
      'recentFirstOutbox',
      'possibleRecipients'
    ]),
    outboxPageLength: function() {
      return Math.ceil(this.outboxQueryTotal / this.limit);
    },
    recipients () {
    },
    messageList () {
      return this.recentFirstOutbox
    },
    composeFieldsPresent () {
      if (this.replyingToMessage) {
        if (this.newMessageBody) {
          return true
        }
      }
      if (
        this.newMessageTo &&
        this.newMessageBody
      ) {
        return true
      }
      return false
    },
    //filteredOutboxMessages () {
      //if (!this.outboxSearch) {
        //return this.recentFirstOutbox
      //} else {
        //const search = this.outboxSearch.toLowerCase()
        //return this.recentFirstOutbox.filter(function(message){
          //const subject = message.subject ? message.subject : ''
          //return subject.toLowerCase().indexOf(search) > -1 ||
                 //message.message.toLowerCase().indexOf(search) > -1 ||
                 //message.sender.displayName.toLowerCase().indexOf(search) > -1
        //})
      //}
    //},
  },
  watch: {
      outboxSearch: function(search) {
        if (!search) {
          this.outboxPage = 1;
          this.doSearchOutbox();
        }
        this.outboxPage = 1;
        this.searchOutboxDebounced();
      },

      outboxPage: function(val) {
        this.doSearchOutbox();
      },
  },
  data () {
    return {
      outboxPage: 1,
      outboxQueryTotal: 1,
      searching: false,
      limit: 40,
      outboxSearch: '',
      viewingArchive: false,
      viewedMessage: null,
      composeDialog: false,
      messageSending: false,
      replyingToMessage: null,
      newMessageTo: null,
      newMessageSubject: null,
      newMessageBody: null,
      newMessageInReplyToId: null,
    }
  },
  methods: {
      doSearchOutbox() {
        this.$store
          .dispatch('messages/searchOutbox', {
            page: this.outboxPage,
            limit: this.limit,
            searchTerm: this.outboxSearch,
          })
          .then(res => {
            this.searching = false;
            this.outboxQueryTotal = res.queryTotal;
          });
      },

      searchOutboxDebounced() {
        this.outboxSearch = this.outboxSearch.toLowerCase();

        this.searching = true;
        // debounce
        // cancel pending call
        clearTimeout(this._outboxSearchTimer);

        // delay new call 500ms
        this._outboxSearchTimer = setTimeout(() => {
          this.doSearchOutbox();
        }, 500);
      },

    messageClasses (message) {
      return {
        'blue lighten-4': message.systemMessage && !message.read,
        'blue lighten-5': message.systemMessage && message.read,
      }
    },
    fetchData () {
      this.$store.dispatch('messages/getOutbox', {page: 1, limit: this.limit})
      .then(res => {
        this.outboxQueryTotal = res.queryTotal;
        if (this.$route.params.messageId) {
          const messageId = this.$route.params.messageId
          const message = this.outboxMessages.find(m => m.id == messageId)
          this.setViewedMessage(message)
        }
      })
    },

    archive(message) {
      this.viewedMessage = null;
      this.$store.dispatch('messages/markArchived', message.id)
    },

    viewInbox () {
      this.$router.replace({ name: 'messages' })
    },

    viewMessage (message) {
      this.setViewedMessage(message)
    },
    setViewedMessage (message) {
      this.viewedMessage = message
    },
    collapseMessage () {
      // this.$router.push({ name: 'messages' })
      this.viewedMessage = null
    },
    toggleFlagged (message) {
      if (message.flagged) {
        this.$store.dispatch('messages/markUnflagged', message.id)
      } else {
        this.$store.dispatch('messages/markFlagged', message.id)
      }
    },
    truncate (message, chars) {
      if ( message && message.length > chars ) {
        return `${ message.substring(0, chars - 2) }...`
      } else if ( !message ) {
        return "<No Subject>"
      } else {
        return message
      }
    }
  }
}
</script>

<style scoped>
.hover-expand {
  display: none;
  position: absolute;
  left: -6px;
}
.inbox-tools {
  opacity: 1;
  display: none;
  position: absolute;
  right: 185px;
  bottom: 0px;
}
.message-in-list:hover .hover-expand {
  display: block;
}
.message-in-list:hover .inbox-tools {
  display: block;
}
.message-in-list.flagged-border {
  border-left: 2px solid orange !important;
}

.flagged-border {
  border-left: 2px solid orange !important;
}
</style>

<style>
</style>
